import React from "react";

// components
import SalesTable from "components/Cards/SalesTable";

export default function Dashboard() {
  return (
    <>
      <div className="flex flex-wrap">
        <SalesTable />
      </div>
    </>
  );
}
